import React, { useMemo } from 'react';
import clsx from 'clsx';
import hexToRgba from 'hex-to-rgba';
import TagModel from '../../Types/Tag';

interface TagProps {
  tagSize?: 'small' | 'medium' | 'large';
}

const Tag: React.FC<
  TagProps & React.HTMLAttributes<HTMLDivElement> & TagModel
> = ({
  tagSize = 'small',
  id,
  color,
  textColor,
  className,
  sortIndex,
  ...props
}) => {
  const sizeClass = useMemo(() => {
    switch (tagSize) {
      case 'small':
        return 'text-xs';
      case 'large':
      case 'medium':
      default:
        return 'text-sm';
    }
  }, [tagSize]);

  return (
    <div
      {...props}
      style={{
        ...props.style,
        color: textColor,
        backgroundColor: color ? hexToRgba(color, 0.9) : undefined,
        borderColor: color,
      }}
      className={clsx(
        className,
        'rounded-md bg-opacity-white-90 px-1.5 py-1 font-normal uppercase leading-3 tracking-[0.075em] text-gray-700',
        sizeClass
      )}
    />
  );
};

export default Tag;
